import React from 'react'
import Banner from './Banner'
import News from '../news/News'


const Index = ()=>{
    return(
        <React.Fragment>
             <Banner/>
                <News/>
        </React.Fragment>
    )
}

export default Index